var _style, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkedIn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{clip-path:url(#SVGID_00000119808658738479763450000006004524889118095536_);fill:#0073B6;}\r\n\t.st1{clip-path:url(#SVGID_00000119808658738479763450000006004524889118095536_);fill:#FFFFFF;}\r\n")), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    width: 24,
    height: 24
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000029029954224617878410000010703262168896219530_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000029029954224617878410000010703262168896219530_)",
      fill: "#0073B6"
    },
    d: "M12,0 c6.63,0,12,5.37,12,12s-5.37,12-12,12S0,18.63,0,12S5.37,0,12,0"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000029029954224617878410000010703262168896219530_)",
      fill: "#FFFFFF"
    },
    d: "M9.32,7.64 c0,0.91-0.73,1.64-1.64,1.64c-0.91,0-1.64-0.73-1.64-1.64C6.04,6.74,6.77,6,7.67,6c0,0,0,0,0,0C8.58,6,9.31,6.73,9.32,7.64"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000029029954224617878410000010703262168896219530_)",
      fill: "#FFFFFF"
    },
    d: "M6.82,9.96h1.72 c0.22,0,0.41,0.18,0.41,0.41v7.23c0,0.22-0.18,0.41-0.41,0.41H6.82c-0.22,0-0.41-0.18-0.41-0.41v-7.23 C6.41,10.14,6.59,9.96,6.82,9.96"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000029029954224617878410000010703262168896219530_)",
      fill: "#FFFFFF"
    },
    d: "M17.96,14.13v3.5 c0,0.2-0.17,0.37-0.37,0.37h-1.85c-0.21,0-0.37-0.17-0.37-0.37v-3.39c0-0.51,0.15-2.21-1.32-2.21c-1.14,0-1.37,1.17-1.42,1.7v3.91 c0,0.2-0.17,0.36-0.37,0.36h-1.79c-0.2,0-0.37-0.16-0.37-0.37c0,0,0,0,0,0v-7.3c0-0.21,0.17-0.37,0.37-0.37c0,0,0,0,0,0h1.79 c0.21,0,0.38,0.16,0.38,0.37c0,0,0,0.01,0,0.01v0.63c0.42-0.63,1.05-1.12,2.39-1.12C17.98,9.84,17.96,12.61,17.96,14.13"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedIn);
export default __webpack_public_path__ + "static/media/linkedIn.565214198ddc67deb61c63ef22ec40eb.svg";
export { ForwardRef as ReactComponent };